/** Prefixo do seletor de seções do mobile (Figma: "Seção: Base Técnica"). */
export const SECOES_MENU_SELECT_PREFIX = "Seção:";

/** Marca o item da seção ativa: a View a renderiza a partir do VM, e o VM a procura para rolar o menu até o item. */
export const SECOES_MENU_ATRIBUTO_ATIVO = "data-secao-ativa";
